import { createVanIconComponent } from "./van"

const Diamond = createVanIconComponent("diamond")
export default Diamond
